<template>
  <v-autocomplete
    ref="autocomplete"
    class="autoComplete"
    :disabled="showReadOnly"
    :items="items"
    density="compact"
    variant="outlined"
    :item-title="getItemTitle"
    :item-value="getItemValue"
    :placeholder="placeholder"
    :rules="rules"
    :multiple="multiple"
    v-model="localValue"
    v-model:search="searchQuery"
    @update:menu="onMenuUpdate"
    @update:modelValue="onModelUpdate"
  ></v-autocomplete>
</template>

<script>
export default {
  name: "AutoComplete",
  props: {
    modelValue:  { default: null },
    items:       { type: Array,   default: () => [] },
    // Vuetify-style props (from FormBuilder)
    itemTitle:   { type: [String, Function], default: null },
    itemValue:   { type: [String, Function], default: null },
    // Legacy prop names
    name:        { type: String,  default: null },
    value:       { type: String,  default: null },
    placeholder: { type: String,  default: "" },
    rules:       { type: Array,   default: () => [] },
    showReadOnly:{ type: Boolean, default: false },
    multiple:    { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "change"],
  data() {
    return {
      searchQuery: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.modelValue; },
      set(val) { this.onModelUpdate(val); },
    },
  },
  watch: {
    modelValue() {
      if (this.multiple) {
        this.clearSearch();
      }
    },
  },
  methods: {
    clearSearch() {
      if (this.multiple) {
        this.searchQuery = "";
        this.$nextTick(() => {
          this.searchQuery = "";
        });
      }
    },
    onMenuUpdate(isOpened) {
      if (!isOpened && this.multiple) {
        this.clearSearch();
      }
    },
    getItemTitle(item) {
      if (item === null || item === undefined) return "";
      const raw = (typeof item === "object" && item !== null && "raw" in item && item.raw !== undefined) ? item.raw : item;
      if (typeof this.itemTitle === "function") return this.itemTitle(raw);
      if (typeof raw !== "object" || raw === null) return String(raw);
      const titleKey = this.itemTitle || this.name;
      if (titleKey && raw[titleKey] !== undefined) return raw[titleKey];
      return raw.name ?? raw.label ?? raw.text ?? raw.title ?? raw.value ?? raw.id ?? String(raw);
    },
    getItemValue(item) {
      if (item === null || item === undefined) return null;
      const raw = (typeof item === "object" && item !== null && "raw" in item && item.raw !== undefined) ? item.raw : item;
      if (typeof this.itemValue === "function") return this.itemValue(raw);
      if (typeof raw !== "object" || raw === null) return raw;
      const valueKey = this.itemValue || this.value;
      if (valueKey && raw[valueKey] !== undefined) return raw[valueKey];
      return raw.id ?? raw.value ?? raw.key ?? raw.name ?? raw;
    },
    onModelUpdate(val) {
      if (this.multiple) {
        this.clearSearch();
      }
      this.$emit("update:modelValue", val);
      this.$emit("change", val);
    },
  },
};
</script>
